import Login from 'i18n/nl/Login';
import Offers from 'i18n/nl/Offers';
import DatesUnits from 'i18n/nl/DatesUnits';
import DownloadMobileApp from 'i18n/nl/DownloadMobileApp';
import General from 'i18n/nl/General.json';
import OfferDetail from 'i18n/nl/OfferDetail';
import Jobs from 'i18n/nl/Jobs';
import PendingJobDetail from 'i18n/nl/PendingJobDetail';
import InTransitJobDetail from 'i18n/nl/InTransitJobDetail';
import RecoverPassword from 'i18n/nl/RecoverPassword';
import Chat from 'i18n/nl/Chat';
import Banner from 'i18n/nl/Banner';
import Alerts from 'i18n/nl/Alerts';
import Pods from 'i18n/nl/Pods';
import AccountSettings from 'i18n/nl/AccountSettings';
import Documents from 'i18n/nl/Documents';

const lang = {
  Login,
  Offers,
  DatesUnits,
  DownloadMobileApp,
  General,
  OfferDetail,
  Documents,
  Jobs,
  PendingJobDetail,
  InTransitJobDetail,
  RecoverPassword,
  Chat,
  Banner,
  Alerts,
  Pods,
  AccountSettings
};

export default lang;
